import { render, staticRenderFns } from "./tableImpr.vue?vue&type=template&id=2d9afc19"
import script from "./tableImpr.vue?vue&type=script&lang=js"
export * from "./tableImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9afc19')) {
      api.createRecord('2d9afc19', component.options)
    } else {
      api.reload('2d9afc19', component.options)
    }
    module.hot.accept("./tableImpr.vue?vue&type=template&id=2d9afc19", function () {
      api.rerender('2d9afc19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/ibm/tableImpr.vue"
export default component.exports